export class FlatPickrModel {
  /* if true; dates will be parsed; formatted; and displayed in UTC.
 preloading date strings w/ timezones is recommended but not necessary */
  utc: boolean = false;

  // wrap: see https://chmln.github.io/flatpickr/#strap
  wrap: boolean = false;

  // enables week numbers
  weekNumbers: boolean = false;

  allowInput: boolean = false;

	/*
 	clicking on input opens the date(time)picker.
 	disable if you wish to open the calendar manually with .open()
 */
  clickOpens: boolean = true;

  // display time picker in 24 hour mode
  time_24hr: boolean = false;

  // enables the time picker functionality
  enableTime: boolean = false;

  // noCalendar: true will hide the calendar. use for a time picker along w/ enableTime
  noCalendar: boolean = false;

  // more date format chars at https://chmln.github.io/flatpickr/#dateformat
  dateFormat: string = "Y-m-d";

  // altInput - see https://chmln.github.io/flatpickr/#altinput
  altInput: string = null;

  // the created altInput element will have this class.
  altInputClass: string = "";

  // same as dateFormat; but for altInput
  altFormat: "F j; Y"; // defaults to e.g. June 10; 2016

  // defaultDate - either a datestring or a date object. used for datetimepicker"s initial value
  defaultDate: any = null;

  // initial value in the hour element
  defaultHour: number = 0;

  // the minimum date that user can pick (inclusive)
  minDate: any = null;

  // the maximum date that user can pick (inclusive)
  maxDate: any = null;

  // dateparser that transforms a given string to a date object
  parseDate: any = null;

  // see https://chmln.github.io/flatpickr/#disable
  enable: any = [];

  // see https://chmln.github.io/flatpickr/#disable
  disable: any = [];

  // display the short version of month names - e.g. Sep instead of September
  shorthandCurrentMonth: boolean = true;

  // displays calendar inline. see https://chmln.github.io/flatpickr/#inline-calendar
  inline: boolean = false;

  // position calendar inside wrapper and next to the input element
  // leave at false unless you know what you"re doing
  static: boolean = false;

  // code for previous/next icons. this is where you put your custom icon code e.g. fontawesome
  prevArrow: string = "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>";
  nextArrow: string = "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>";

  // enables seconds in the time picker
  enableSeconds: boolean = false;

  // step size used when scrolling/incrementing the hour element
  hourIncrement: number = 1;

  // step size used when scrolling/incrementing the minute element
  minuteIncrement: number = 5;

  // disable native mobile datetime input support
  disableMobile: boolean = false;

  // onChange callback when user selects a date or time
  onChange: any = null; // function (dateObj; dateStr) {}

  // called every time calendar is opened
  onOpen: any = null; // function (dateObj; dateStr) {}

  // called every time calendar is closed
  onClose: any = null; // function (dateObj; dateStr) {}

  // called after calendar is ready
  onReady: any = null; // function (dateObj; dateStr) {}

  onValueUpdate: any = null
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/plugins/flatpickr/flatpickr.model.ts